import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useSnackbar } from 'notistack';

import Input from '../../components/Input';
import UnauthorizedLayout from '../../layouts/UnauthorizedLayout';
import useStyles from './styles';

import Card from '../../components/Card';
import Button from '../../components/Button';

import { schema, ForgotPasswordForm } from '../../validations/forgot-password.validation';
import useAuthentication from '../../hooks/providers/useAuthentication';
import AuthenticationError from '../../errors/authentication.error';

export const ForgotPassword = (): JSX.Element => {
  const styles = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const authentication = useAuthentication();

  const {
    register,
    handleSubmit,
    formState: { isSubmitting, errors },
  } = useForm<ForgotPasswordForm>({
    mode: 'onChange',
    resolver: yupResolver(schema),
  });

  const onHandleSubmitHandler = async ({ email }: ForgotPasswordForm) => {
    try {
      await authentication.forgotPassword(email);
    } catch (err) {
      const error = new AuthenticationError(err);
      enqueueSnackbar(error.message, { variant: 'error' });
    }
  };

  return (
    <UnauthorizedLayout>
      <form className={styles.form} onSubmit={handleSubmit(onHandleSubmitHandler)}>
        <Card className={styles.logoutCard}>
          <span className={styles.title}>Recuperação de senha</span>
          <Input
            label="e-mail"
            autoFocus
            placeholder="digite o email cadastrado"
            helperText={errors.email?.message || ' '}
            error={Boolean(errors.email?.message)}
            validationRegister={register('email')}
          />
          <Button type="submit" loading={isSubmitting}>
            Enviar
          </Button>
          <div className={styles.login}>
            <Link to="/login">fazer login</Link>
          </div>
        </Card>
      </form>
    </UnauthorizedLayout>
  );
};

export default ForgotPassword;
